// extracted by mini-css-extract-plugin
module.exports = {"thumbprint":"style-module_thumbprint__XzcnT0_Cfgg0dmE1CG3C"};